


























































































































































import {
  getExchangeListData,
  getExchangeListApi,
  agreeExchangeApi,
} from "@/api/integral";
import { dateFormat } from "@/utils/timeFormat";
import cancelDialog from "./cancelDialog.vue";
import detailDialog from "./detailDialog.vue";
import {
  searchStudent,
  commonSearchGoodsData,
  commonSearchGoodsApi,
} from "@/api/globalSearch";
import { Vue, Component } from "vue-property-decorator";
import { PageModule } from "@/store/module/page";
@Component({
  name: "integralExchangeList",
  components: {
    cancelDialog,
    detailDialog,
  },
})
export default class extends Vue {
  searchInfo: any = {
    status: -1,
  };
  refreshCountdown: number = 0;
  studentList: any[] = [];
  goodsList: any[] = [];
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      const params = this.$route.params;
      if (params.status) {
        this.searchInfo.status = Number(params.status);
      }
    }
    this.handleSearch();
    this.handleSearchStudent("");
    this.handleSearchGoods("");
  }
  getList(pages: { page: number; page_size: number }, cb?: Function) {
    const params: getExchangeListData = {
      ...pages,
    };
    if (this.searchInfo.student_id) {
      params.student_id = this.searchInfo.student_id;
    }
    if (this.searchInfo.goods_id) {
      params.goods_id = this.searchInfo.goods_id;
    }
    if (this.searchInfo.status >= 0) {
      params.status = this.searchInfo.status;
    }
    getExchangeListApi(params).then((res: any) => {
      if (!res.data.list) {
        res.data.list = [];
      }
      res.data.list.map((item: any) => {
        item.create_time = dateFormat(
          "YYYY-mm-dd HH:MM",
          item.create_time * 1000
        );
      });
      this.tableData = res.data.list;
      this.page = res.data.page;
      this.total = res.data.total;
      if (cb) {
        cb();
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  clickRefresh() {
    if (this.refreshCountdown > 0) {
      return false;
    }
    this.getList(
      {
        page: this.page,
        page_size: this.pageSize,
      },
      () => {
        this.$message({
          type: "success",
          message: "数据已更新",
        });
        this.refreshCountdown = 5;
        const clock = setInterval(() => {
          if (this.refreshCountdown === 0) {
            clearInterval(clock);
          } else {
            this.refreshCountdown = this.refreshCountdown - 1;
          }
        }, 1000);
      }
    );
  }
  handleRefresh() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  handleSearchStudent(v: any) {
    searchStudent({
      page: 1,
      page_size: 50,
      key_word: v,
      status: [2],
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentList = res.data.list;
      }
    });
  }
  handleSearchGoods(v: string) {
    const params: commonSearchGoodsData = {
      page: 1,
      page_size: 50,
    };
    if (v) {
      params.key_word = v;
    }
    commonSearchGoodsApi(params).then((res: any) => {
      if (res.error_code === 0) {
        this.goodsList = res.data.list;
      }
    });
  }
  handleExchange(row: any) {
    this.$confirm(
      "请确定商品库存信息，完成兑换后自动扣除积分，且不能取消。确定要兑换商品？",
      `确定兑换 - ${row.goods.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        agreeExchangeApi({ order_id: row.order_id }).then(() => {
          this.$message({
            type: "success",
            message: "兑换成功!",
          });
          this.handleRefresh();
        });
      })
      .catch(() => {});
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
